import {Wrapper} from './style';

// Component
import Hero from './Hero';
import About from './About'
import Services from './Services';
import Footer from './Footer';
import BlogPosts from './BlogPosts';
import Collaborate from './Collaborate';

const Home = ({ webConfig, cities, specialties }) => {
    return (
        <Wrapper>
            <Hero 
                webConfig={webConfig}
                cities={cities}
                specialties={specialties}
            />
            <About 
                webConfig={webConfig}
            />
            <Services
                webConfig={webConfig}
            />
            <BlogPosts
                webConfig={webConfig}
            />
            <Collaborate
                webConfig={webConfig}
            />
            <Footer
                webConfig={webConfig}
            />
        </Wrapper>
    )
}

export default Home;